<template>
    <list-page-shell title="待提交">
        <order-workbench
            :show-title="false"
            :show-announcement-columns="false"
            :hide-primary-actions="true"
            :extra-query-params="{ pending_submit_list: 1 }"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'PendingSubmitList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/PendingSubmitList.vue